/**
 * Surgeon Supply Suggestions — Mobile-first end-of-day review.
 */

import { SurgeonLayout } from '@/components/surgeon/SurgeonLayout';
import { SurgeonSupplySuggestions } from '@/components/supply/SurgeonSupplySuggestions';

export default function SurgeonSupplyReview() {
  return (
    <SurgeonLayout>
      <SurgeonSupplySuggestions />
    </SurgeonLayout>
  );
}
